import React from 'react'
import Board from 'react-trello'
import classnames from 'classnames'
import { BoardCheckinData } from '../models/client/checkins'
import { Card } from './KanbanCard'

type Props = {
    className?: string
    data: BoardCheckinData
    isLaneDraggable?: boolean
    onDataChange?: (newData) => void
    onCardClick?: (cardId, metadata, laneId) => void
    handleDragEnd?: (cardId, sourceLaneId, targetLaneId, position, cardDetails) => void
}

const KanbanBoard = (props: Props): JSX.Element => {
    const { className, data, isLaneDraggable, onDataChange, onCardClick, handleDragEnd } = props
    const css = `
        .smooth-dnd-container {
            min-height: calc(100vh);
        }
        .smooth-dnd-draggable-wrapper article header {
            border-bottom: 1px solid #21325E;
        }
    `
    return (
        <div className={className ? classnames(className, 'kanban-wrapper') : 'kanban-wrapper'}>
            <style>{css}</style>
            <Board
                data={data}
                draggable
                laneDraggable={isLaneDraggable}
                cardDraggable
                style={{
                    backgroundColor: 'white',
                    height: '100%',
                }}
                hideCardDeleteIcon
                onDataChange={onDataChange}
                onCardClick={onCardClick}
                handleDragEnd={handleDragEnd}
                components={{ Card }}
            />
        </div>
    )
}

export default KanbanBoard
